'use client';

/**
 * The cancel to show during the ring, or null.
 *
 * Non-null means: the wake word heard its name, the session is not up yet, and
 * the user can still say that wasn't me. Both composers render off this and
 * nothing else — see `pending-cancel.ts` for why it is a store.
 */
import { useSyncExternalStore } from 'react';
import { getPendingWakeCancel, subscribePendingWakeCancel } from './pending-cancel';

/** Never on the server: there is no microphone and no session to cancel. */
const none = () => null;

export function usePendingWakeCancel(): (() => void) | null {
  return useSyncExternalStore(subscribePendingWakeCancel, getPendingWakeCancel, none);
}

/**
 * What the composer says while it is the cancel.
 *
 * 🚨 It names the CAUSE, not the action. "Cancel" alone leaves an owner staring
 * at a session they did not start with no idea why it started; "Heard 'Alright
 * Mucka'" is the honest answer and it is the whole reason this is worth
 * building rather than just a stop button.
 *
 * One constant, both surfaces. The mobile bar and the desktop panel share no
 * code, and a promise about a microphone worded two ways is a promise nobody
 * can check.
 */
export const WAKE_WORD_CANCEL_PLACEHOLDER = 'Heard "Alright Mucka" — tap to cancel';
